module.exports = __webpack_public_path__ + "static/media/0p.d9786cf0.png";